import React from 'react'
import {
  Grid,
  CircularProgress,
  TextField,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { Page, Header, CustomButton, SecaoGenerica } from 'components'
import { ConfirmarIdentidade } from 'components/ConfirmarIdentidade'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'
import { cutMaxLength } from 'utils/helpers'
import { useParams } from 'react-router'
import { useEncaminharVestigio } from './hooks/useEncaminharVestigio'
import useStyles from './styles'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)

export const EncaminharVestigio = (props) => {
  const { route } = props
  const params = useParams()
  const classes = useStyles()

  const {
    formEncaminhar,
    formEncaminharSituacional,
    setores,
    usuarios,
    abrirConfirmarIdentidade,
    setAbrirConfirmarIdentidade,
    processandoDados,
    vestigio,
    processandoVestigio,
    processandoOperacao,
    isFormError,
    handleSubmit,
    handleSubmitParaUsuario,
    router,
  } = useEncaminharVestigio({
    idVestigio: params.id,
    paraUsuario: route.paraUsuario,
  })

  const situacoesVests = [
    { label: 'Vestígio para entrega ao destino final', slug: 'PARA_ENTREGA' },
    { label: 'Vestígio para armazenamento', slug: 'PARA_ARMAZENAMENTO' },
  ]

  const isLoading = processandoVestigio || processandoDados

  const getSetorLabel = (option) => {
    if (!option) return ''
    const setorNome = option.nome?.toUpperCase() || ''
    const divisaoSigla = option.divisao?.sigla?.toUpperCase() || ''
    const regionalSigla = option.divisao?.regional?.sigla?.toUpperCase() || ''
    const orgaoSigla = option.divisao?.regional?.orgao?.sigla?.toUpperCase() || ''
    return [setorNome, divisaoSigla, regionalSigla, orgaoSigla].filter(Boolean).join(' / ')
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />

      {isLoading ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container spacing={3} style={{ marginTop: '16px' }}>



          <Grid item md={3} sm={6} xs={12}>
            <TextField
              error={formEncaminhar.hasError('lacre')}
              helperText={formEncaminhar.hasError('lacre') ? formEncaminhar.formState.errors.lacre[0] : null}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              label="NÚMERO DO LACRE"
              name="lacre"
              onChange={(e) => formEncaminhar.handleChangeWithModification(e, maxLength250)}
              value={formEncaminhar.formState.values.lacre || ''}
            />
            <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
              Caracteres restantes: {250 - (formEncaminhar.formState.values.lacre?.length || 0)}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>TIPO DA EMBALAGEM</Typography>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="tipo-embalagem"
                name="tipoEmbalagem"
                value={formEncaminhar.formState.values.tipoEmbalagem || null}
                onChange={formEncaminhar.handleChange}
                style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}
              >
                <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />
                <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
              </RadioGroup>
            </FormControl>
          </Grid>

          {formEncaminhar.formState.values.tipoEmbalagem === 'OUTRO' && (
            <Grid item xs={12}>
              <TextField
                label="OUTRO TIPO DE EMBALAGEM"
                name="outroTipoEmbalagem"
                variant="outlined"
                value={formEncaminhar.formState.values.outroTipoEmbalagem || ''}
                onChange={formEncaminhar.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          )}



          {/* Seção: Dados de Encaminhamento */}
          <Grid item xs={12}>
            <SecaoGenerica titulo="Dados de Encaminhamento" spacing={3}>

              {/* Usuário Destino (Condicional) */}
              {route.paraUsuario && (
                <Grid item xs={12}>
                  <Autocomplete
                    name="usuarioDestino"
                    value={formEncaminhar.formState.values.usuarioDestino || null}
                    noOptionsText="Sem informações"
                    options={usuarios}
                    onChange={(event, newValue) => {
                      formEncaminhar.handleChangeNewValueByNameProperty(event, newValue, 'usuarioDestino')
                    }}
                    getOptionSelected={(option, value) => option.id === value?.id}
                    getOptionLabel={(option) => `${option.nome || ''}${option.cargo ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
                    renderOption={(option) => `${option.nome || ''}${option.cargo ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="USUÁRIO DESTINO"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                      />
                    )}
                  />
                </Grid>
              )}

              {/* Setor Destino */}
              <Grid item xs={12}>
                <Autocomplete
                  name="setDest"
                  value={formEncaminhar.formState.values.setDest || null}
                  noOptionsText="Sem informações"
                  options={route.paraUsuario ? formEncaminhar?.formState?.values?.usuarioDestino?.setores || [] : setores}
                  onChange={(event, newValue) => {
                    formEncaminhar.handleChangeNewValueByNameProperty(event, newValue, 'setDest')
                  }}
                  getOptionSelected={(option, value) => option.id === value?.id}
                  getOptionLabel={getSetorLabel}
                  renderOption={getSetorLabel}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={route.paraUsuario ? 'SETOR DO USUÁRIO DESTINO' : 'SETOR DESTINO'}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                    />
                  )}
                />
              </Grid>

              {/* Situação Situacional para o Setor 184 */}
              {!route.paraUsuario && formEncaminhar?.formState?.values?.setDest?.id === 184 && (
                <Grid item xs={12}>
                  <Autocomplete
                    name="situacaoVest"
                    value={situacoesVests.find((opt) => opt.slug === formEncaminharSituacional.formState.values.situacaoVest) || null}
                    noOptionsText="Sem informações"
                    options={situacoesVests}
                    onChange={(event, newValue) => {
                      formEncaminharSituacional.handleChangeNewValueByNameProperty(event, newValue ? newValue.slug : null, 'situacaoVest')
                    }}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="SITUAÇÃO DO VESTÍGIO"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                      />
                    )}
                  />
                </Grid>
              )}

              {/* Setor de entrega se for para entrega */}
              {!route.paraUsuario &&
                formEncaminhar?.formState?.values?.setDest?.id === 184 &&
                formEncaminharSituacional?.formState?.values?.situacaoVest === 'PARA_ENTREGA' && (
                  <Grid item xs={12}>
                    <Autocomplete
                      name="setEntregaVest"
                      value={formEncaminharSituacional.formState.values.setEntregaVest || null}
                      noOptionsText="Sem informações"
                      options={setores}
                      onChange={(event, newValue) => {
                        formEncaminharSituacional.handleChangeNewValueByNameProperty(event, newValue, 'setEntregaVest')
                      }}
                      getOptionSelected={(option, value) => option.id === value?.id}
                      getOptionLabel={getSetorLabel}
                      renderOption={getSetorLabel}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="SETOR A SER ENTREGUE O VESTÍGIO"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          required
                        />
                      )}
                    />
                  </Grid>
                )}

              {/* Observações */}
              <Grid item xs={12}>
                <TextField
                  error={formEncaminhar.hasError('observacoesVestigio')}
                  fullWidth
                  helperText={formEncaminhar.hasError('observacoesVestigio') ? formEncaminhar.formState.errors.observacoesVestigio[0] : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  label="OBSERVAÇÕES"
                  name="observacoesVestigio"
                  onChange={(e) => formEncaminhar.handleChangeWithModification(e, maxLength250)}
                  value={formEncaminhar.formState.values.observacoesVestigio || ''}
                  multiline
                  minRows={3}
                />
                <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
                  Caracteres restantes: {250 - (formEncaminhar.formState.values.observacoesVestigio?.length || 0)}
                </Typography>
              </Grid>
            </SecaoGenerica>
          </Grid>

          {/* Rodapé e Ações */}
          <Grid item xs={12}>
            <Divider className={classes.dividerTitle} />
            <div className={classes.buttons}>
              <CustomButton
                colorType="primary"
                variant="outlined"
                onClick={() => router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)}
                startIcon={<ArrowBackIcon />}
              >
                Voltar
              </CustomButton>
              <CustomButton
                colorType="primary"
                disabled={isFormError || processandoOperacao}
                isLoading={processandoOperacao}
                startIcon={<CheckIcon />}
                onClick={handleSubmit}
              >
                Confirmar
              </CustomButton>
            </div>
          </Grid>

        </Grid>
      )}

      {route.paraUsuario && formEncaminhar.formState.values?.usuarioDestino?.cpf && (
        <ConfirmarIdentidade
          aberto={abrirConfirmarIdentidade}
          setAberto={setAbrirConfirmarIdentidade}
          callback={handleSubmitParaUsuario}
          titulo={`Aceitar Vestígio - ${formEncaminhar.formState.values.usuarioDestino.nome.split(' ')[0]}`}
          CPFparaValidacao={formEncaminhar.formState.values.usuarioDestino.cpf}
        />
      )}
    </Page>
  )
}
export default EncaminharVestigio
